import { ChevronLeft } from 'lucide-react'
import React from 'react'
import { useLocation, useNavigate } from 'react-router'

const BackHeader = ({title, className, onBack}) => {
  const navigate = useNavigate();
  const {pathname, key} = useLocation();

  const goBack = () => {
    if (key !== 'default') {
      navigate(-1);
    } else if (pathname.startsWith('/admin')) {
        navigate('/admin', {replace: true})
      } else {
        navigate('/', {replace: true});
      }
  }
  
  return (
    <div className={`tw-w-full tw-flex tw-items-center tw-text-md tw-h-12 ${className || 'tw-bg-primary tw-text-white'}`}>
      <ChevronLeft className='tw-my-2 tw-mx-2' onClick={onBack || goBack} />
      <span>{title}</span>
    </div>
  )
}

export default BackHeader